<template>
    <div class="mod mod-half mod-fbl">
        <h2><i>5</i>封板率<span class="icon-help" v-on:click="toggle">?</span></h2>
        <div class="chart-tab">
            <span v-for="(item,index) in tabs" :class="{'cur':curTab==index}" @click="curTab=index,tabChange(index)">{{item}}</span>
        </div>
        <keep-alive>
            <component v-bind:is="curTabComponent"></component>
        </keep-alive>
        <p class="help-pop" style="display: block" v-show="isHelp">自然板是指沪深A股自然涨停的股票（非一字板涨停），触及涨停包括自然板和涨停被打开的股票；若封板率高，主力资金流出的可能性较小，反之封板率低，主力资金流出的可能性大。</p>
    </div>
</template>

<script>
    import fblMonth from './fblMonth.vue';      // 日
    import fblToday from './fblToday.vue';      // 月
    export default {
        data () {
            return {
                isHelp:false,
                tabs:['日','月'],
                curTab:0,
                curTabComponent: 'fblToday'
            }
        },
        components: {
            fblMonth,
            fblToday
        },
        methods: {
            toggle: function () {
                this.isHelp =! this.isHelp;
            },
            tabChange:function(index){
                switch(index)
                {
                    case 1:
                        this.curTabComponent = 'fblMonth';
                        break;
                    default:
                        this.curTabComponent = 'fblToday';
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/home/components/fbl.vue